import { NavLink, useNavigate } from "react-router-dom";
import { Button, Form, Input } from "antd";
import { useGenerateResetPasswordTokenMutation } from "./forgotPassword.service";
import "../login/style.css";
import "./style.css";

export default function ForgotPasswordPage() {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [requestGenerateResetPasswordToken, { isLoading, isSuccess }] =
    useGenerateResetPasswordTokenMutation();

  const onFinish = async (values) => {
    try {
      await requestGenerateResetPasswordToken(values).unwrap();
    } catch (err) {
      console.log(err);
    }
  };

  const maskEmail = (email) => {
    if (email && email.includes("@")) {
      const [local, domain] = email.split("@");

      if (local.length <= 2) {
        return local[0] + "*".repeat(local.length - 1) + "@" + domain;
      }

      const visiblePart = local.slice(0, 2);
      const maskedPart = "*".repeat(local.length - 2);
      return visiblePart + maskedPart + "@" + domain;
    }
    return "";
  };

  return (
    <div className="signincontainer signup-page auth-page">
      <div className="saas-card auth-card">
        <div className="auth-brand">
          <div className="auth-logo-wrap">
            <img src="/mark1.jpg" alt="SFBB Pro" />
          </div>
        </div>

        {isSuccess ? (
          <div style={{ textAlign: "center" }}>
            <div className="auth-status-pill">Email sent</div>
            <div className="auth-heading">Check your inbox</div>
            <p className="auth-copy">
              We’ve sent password reset instructions to{" "}
              <span className="auth-email-highlight">
                {maskEmail(form.getFieldValue("email"))}
              </span>
              .
            </p>
            <div className="auth-tip" role="note">
              <strong>Didn’t get it?</strong> Check your Spam or Junk folder.
              You can also request another email from this page later.
            </div>
            <div className="auth-actions" style={{ marginTop: "1.15rem" }}>
              <Button
                size="large"
                block
                className="signup-cta-btn"
                onClick={() => navigate("/login")}
              >
                Back to login
              </Button>
            </div>
          </div>
        ) : (
          <>
            <div className="auth-heading">Forgotten password</div>
            <p className="auth-copy">
              Enter your email and we’ll send instructions to reset your
              password.
            </p>

            <Form
              onFinish={onFinish}
              form={form}
              layout="vertical"
              className="auth-form"
              requiredMark={false}
            >
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  { required: true, message: "Please input your email!" },
                  {
                    type: "email",
                    message: "Please enter a valid email address!",
                  },
                ]}
              >
                <Input
                  placeholder="Enter your email"
                  className="auth-input"
                  size="large"
                />
              </Form.Item>

              <Button
                htmlType="submit"
                size="large"
                block
                loading={isLoading}
                className="signup-cta-btn"
              >
                Email me
              </Button>
            </Form>

            <div className="auth-footer-note">
              Remembered it?{" "}
              <NavLink to="/login" className="auth-text-link strong">
                Log in
              </NavLink>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
